<template>
  <v-col cols="12" class="px-md-1">
    <v-expansion-panels v-model="status" flat class="rounded-0">
      <v-expansion-panel class="ev-2 rounded-0">
        <v-expansion-panel-header
          class="py-0 pl-2 pr-4"
          expand-icon="mdi-menu-down"
        >
          <span class="body2-regular">زمان بارگیری</span>
          <v-spacer></v-spacer>
          <div v-if="status != 0" class="my-auto d-flex body2-regular">
            <span v-if="isMultiSender" class="mr-auto">
              <span class="medium-emp">تا</span>
              <span class="logistic--text pr-2" v-text="dates[1].value"></span>
            </span>
            <span v-else class="mr-auto logistic--text">
              {{ dates[0].value }}
            </span>
          </div>
        </v-expansion-panel-header>

        <v-expansion-panel-content class="pa-0 force-padding body2-regular">
          <div
            v-for="(date, i) of dates"
            :key="i"
            class="bg-light-blue pa-2 d-flex mb-2 justify-space-between"
          >
            <span class="medium-emp" v-text="date.title"></span>
            <span v-text="date.day"></span>
            <span v-text="date.value"></span>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-col>
</template>

<script>
export default {
  name: "ShippingDateTimePanel",
  props: {
    load: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      status: null,
      dates: [
        {
          title: "تاریخ",
          day: "",
          value: "نامشخص",
        },
        {
          title: "ساعت",
          day: "",
          value: "نامشخص",
        },
      ],
    };
  },
  mounted() {
    this.initDate();
  },
  methods: {
    initDate() {
      if (!this.load.shipping_start_date) return;

      const day = this.$utils.getJDayOfWeek(this.load.shipping_start_date);
      const date = this.$utils.getJMonthDay(this.load.shipping_start_date);

      this.dates[0].day = day;
      this.dates[0].value = date;

      if (this.isMultiSender) {
        const day = this.$utils.getJDayOfWeek(this.load.shipping_end_date);
        const date = this.$utils.getJMonthDay(this.load.shipping_end_date);

        this.dates[0].title = "از";
        this.dates[1].title = "تا";
        this.dates[1].day = day;
        this.dates[1].value = date;
        return;
      }

      const isEmpty = Object.keys(this.load.loading_start_time).length === 0;
      if (!!this.load.loading_start_time && !isEmpty) {
        this.dates[1].value =
          this.load.loading_start_time.m +
          " : " +
          this.load.loading_start_time.h;
      }
    },
  },
  computed: {
    isMultiSender() {
      if (this.load.shipping_end_date) return true;
      return false;
    },
  },
};
</script>

<style scoped>
.bg-light-blue {
  background-color: rgba(14, 20, 82, 0.04);
}
</style>
